/**
 * Business Intelligence Platform Export Options
 *
 * Power BI and Power Query configurations
 */

import type { ExportOptionGroup } from '@/features/DataHub/modules/Export/types/exportConfig.types';

import { DataThresholdingOutlined, PowerBIIcon, PowerQueryIcon } from './icons';

export const biPlatformsGroup: ExportOptionGroup = {
  groupName: 'Business intelligence platforms',
  GroupIcon: DataThresholdingOutlined,
  options: [
    {
      id: 'power_bi',
      displayName: 'Power BI',
      icon: { url: PowerBIIcon, size: 20 },
      buttonLabel: 'Enable Access',
      disabled: false,
      actionHeading: 'GX Data in Power BI',
      bulletPoints: ['Data in Power BI dashboards.', 'Live connection to refresh with latest data'],
      buttons: [
        {
          label: 'Enable Access',
          action: 'export'
        }
      ],
      preview: {
        type: 'integration'
      }
    },
    {
      id: 'power_query',
      displayName: 'Power Query',
      icon: { url: PowerQueryIcon, size: 16 },
      buttonLabel: 'Copy to clipboard',
      label: 'Excel (PowerQuery)',
      actionHeading: 'PowerQuery (Summary Table)',
      bulletPoints: [
        'Use code in PowerBI or Excel. Data can be refreshed with Data → Refresh',
        'On PC Excel go to Data → Get Data → From Other Sources → Blank Query',
        "Click 'Advanced Editor'; Paste code below; Click 'Done' → 'Close and Load'"
      ],

      disabled: false,
      buttons: [
        {
          label: 'Copy to clipboard',
          action: 'copy'
        },
        {
          label: 'Download',
          action: 'download'
        }
      ],
      showTokenLink: true,
      downloadFileName: 'power_query.m',
      preview: {
        type: 'code',
        language: 'powershell',
        fetchTemplate: true
      }
    }
  ]
};
